import { Dropdown, Menu } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import user from "./../../../../assets/images/user-profile.svg";
import support from "./../../../../assets/images/support.svg";
import logout from "./../../../../assets/images/logout.svg";
import language from "./../../../../assets/images/language.svg";
import backArrow from "./../../../../assets/images/chevron-right.svg";
import ContactSupport from "../contactSupport/ContactSupport";
import { useEffect, useState } from "react";
import Logout from "../logout/Logout";
import { getLocalStorage } from "../../../../utils/localStorage";
import { LANGUAGE } from "../../../symptomCollector/utils/constants";
import { fetchClinicLogo } from "../../service";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../../../../utils/helper";
import dayjs from "dayjs";

const HeaderAppointment = ({
  agentDetails,
  setSelectedLanguage,
  phoneNumber,
  isBackButtonVisible,
  isSCLoggedIn,
}: {
  agentDetails: any;
  setSelectedLanguage: any;
  phoneNumber: string;
  isBackButtonVisible?: boolean;
  isSCLoggedIn: boolean;
}) => {
  const navigate = useNavigate();
  const [showSupport, setShowSupport] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const selectedLanguage = getLocalStorage(LANGUAGE);
  const [logo, setLogo] = useState("");

  const moengageData = {
    "Login Mobile No": phoneNumber,
    "Clinic Id": agentDetails?.hm_id,
    "Clinic Name": agentDetails?.hospital_name,
    "Time Stamp": dayjs().format("YYYY-MM-DD HH:mm:ss"),
  };

  useEffect(() => {
    getClinicLogo();
  }, []);

  const getClinicLogo = async () => {
    if (agentDetails?.logo) {
      const logoRes = await fetchClinicLogo(agentDetails?.logo);
      setLogo(logoRes);
    }
  };

  const userMenu = (
    <Menu>
      <Menu.Item
        key="user"
        disabled
        style={{
          cursor: "default",
          background: "#fff",
          borderRadius: 16,
        }}
        className="flex items-center"
      >
        <div className="flex items-center gap-2">
          <span className="bg-[#5251d733] rounded-[50px] p-[5px] cursor-pointer">
            <img src={user} alt="user" className="w-4 h-4" />
          </span>
          <span style={{ fontWeight: 500, fontSize: 16 }}>
            +91 {phoneNumber}
          </span>
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        key="logout"
        className="flex items-center gap-2 cursor-pointer text-[#B73A3A]"
        style={{ fontWeight: 500, fontSize: 16 }}
        onClick={() => {
          setShowLogout(true);
        }}
      >
        <div className="flex items-center gap-3">
          <img src={logout} alt="logout" />
          <span className="text-gray-700 text-base font-medium">Log Out</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  const ellipsisMenu = (
    <Menu className="bg-white rounded-xl shadow-lg py-2 min-w-[140px] flex flex-col">
      {selectedLanguage && (
        <Menu.Item
          key="language"
          className="flex items-center justify-between cursor-pointer hover:bg-gray-100 rounded-lg px-5 py-2 transition"
          onClick={() => {
            trackEvent("AA_Reselect_Languguage", moengageData);
            setSelectedLanguage(null);
          }}
        >
          <div className="flex items-center justify-between">
            <img src={language} alt="language" />
            <span className="text-gray-700 text-base font-medium">
              Language
            </span>
          </div>
        </Menu.Item>
      )}
      <Menu.Item
        key="support"
        className="cursor-pointer hover:bg-gray-100 rounded-lg px-5 py-2 transition"
        onClick={() => {
          setShowSupport(true);
          trackEvent("AA_Support", moengageData);
        }}
      >
        <div className="flex items-center gap-3">
          <img src={support} alt="support" />
          <span className="text-gray-700 text-base font-medium">Support</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div
      className={`sticky top-0 z-20 border-[#EAECF0]`}
      style={{
        background:
          "linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(250, 248, 253, 1) 100%)",
      }}
    >
      <div className="flex items-center justify-between gap-x-3 p-[15px]">
        <div className="flex items-center gap-x-2 text-sm font-semibold">
          {isBackButtonVisible && (
            <button onClick={handleBack}>
              <img
                src={backArrow}
                alt="back-arrow"
                className="rotate-180 w-6 h-6"
              />
            </button>
          )}
          {agentDetails?.logo ? (
            <img
              src={logo}
              alt="logo"
              className="max-w-[65px] max-h-[65px] object-contain"
            />
          ) : (
            agentDetails?.hospital_name ?? ""
          )}
        </div>
        <div className="flex items-center">
          {phoneNumber && isSCLoggedIn && (
            <Dropdown
              overlay={userMenu}
              trigger={["click"]}
              placement="bottomRight"
              overlayClassName="user-dropdown-menu"
            >
              <span className="bg-[#5251d733] rounded-[50px] p-[5px] cursor-pointer">
                <img src={user} alt="user" className="w-4 h-4" />
              </span>
            </Dropdown>
          )}
          <Dropdown
            overlay={ellipsisMenu}
            trigger={["click"]}
            placement="bottomRight"
            overlayClassName="!p-0"
          >
            <EllipsisOutlined
              style={{
                fontSize: 35,
                writingMode: "vertical-lr",
                transform: "rotate(90deg)",
                width: 28,
                height: 22,
              }}
            />
          </Dropdown>
        </div>
      </div>
      {showLogout && (
        <Logout
          show={showLogout}
          closePopup={() => setShowLogout(false)}
          handleClose={() => {
            window.location.reload();
          }}
        />
      )}
      {showSupport && (
        <ContactSupport
          show={showSupport}
          closePopup={() => setShowSupport(false)}
          agentDetails={agentDetails}
        />
      )}
    </div>
  );
};

export default HeaderAppointment;
